import type React from 'react';

import { PageBody } from '../components/PageBody';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC<EmptyProps> = () => {
	useTrackPageView();

	return <PageBody />;
};
